import { NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'empty',
    loadChildren: () => import('./pages/empty/empty.page.module').then(m => m.EmptyPageModule)
  },
  {
    path: 'view-search',
    loadChildren: () => import ('./pages/vaf-certification-search/vaf-certification-search.module').then(m => m.VafCertificationSearchModule)
  },
  {
    path: 'view-create',
    loadChildren: () => import ('./pages/vaf-certification-create/vaf-certification-create.module').then(m => m.VafCertificationCreateModule)
  },
  {
    path: 'fine-search',
    loadChildren: () => import ('./pages/vaf-fine-search/vaf-fine-search.module').then(m => m.VafFineSearchModule)
  },
  {
    path: 'fine-create',
    loadChildren: () => import ('./pages/vaf-fine-create/vaf-fine-create.module').then(m => m.VafFineCreateModule)
  },
  {
    path: 'backoffice-registrationsearch',
    loadChildren: () => import ('./pages/vaf-registration-search/vaf-registration-search.module').then(m => m.VafRegistrationSearchModule)
  },
  {
    path: 'registration-create-edit',
    loadChildren: () => import ('./pages/vaf-registration-create-edit/vaf-registration-create-edit.module').then(m => m.VafRegistrationCreateEditModule)
  },
  {
    path: 'configuration-authorityprofile',
    loadChildren: () => import ('./pages/vaf-authority-detail/vaf-authority-detail.module').then(m => m.VafAuhotiryDetailModule)
  },
  {
    path: 'configuration-customerslist',
    loadChildren: () => import ('./pages/vaf-customers-list/vaf-customers-list.module').then(m => m.VafCustomersListModule)
  },
  {
    path: 'payment-search',
    loadChildren: () => import ('./pages/vaf-payment-search/vaf-payment-search.module').then(m => m.VafPaymentSearchModule)
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
